/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2022-06-30 11:07:20
 * @LastEditTime: 2023-09-27 15:50:37
 * @LastEditors: WangYuhan
 */
// 身份证号码
export function validateIdCrad(rule, value, callback) {
  rule = [
    /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/,
  ];
  if (!value) {
    callback(new Error('请输入身份证号'));
  }
  if (value) {
    if (value.length == 18) {
      if (!rule[0].test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    } else if (value.length == 15) {
      if (!rule[1].test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    } else {
      callback(new Error('请输入正确的身份证号'));
    }
  }
}
// 收款人姓名
export function validaIteName(rule, value, callback) {
  // rule = /^[0-9a-zA-Z\u4e00-\u9fa5]{2,50}$/;
  rule = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/;
  if (!value) {
    callback(new Error('请输入收款人姓名'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的收款人姓名'));
  } else {
    callback();
  }
}
// 收款账号
export function validaIteCode(rule, value, callback) {
  rule = /^\d{10,}$/;
  if (!value) {
    callback(new Error('请输入收款账号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的收款账号'));
  } else {
    callback();
  }
}
// 收款银行
export function validaIteBank(rule, value, callback) {
  rule = /^[A-Za-z0-9-\(\)\u4e00-\u9fa5]{4,}$/;
  if (!value) {
    callback(new Error('请输入收款银行'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的收款银行'));
  } else {
    callback();
  }
}
// 手机号
export function validaItePhoneNo(rule, value, callback) {
  rule = /^1\d{10}$/;
  if (!value) {
    callback(new Error('请输入手机号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
}
